import React, { useCallback, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

export function useAppToast() {
  const [toast, setToast] = useState({ open: false, message: "", severity: "success" });

  const showToast = useCallback((message, severity = "success") => {
    setToast({ open: true, message, severity });
  }, []);

  const closeToast = useCallback(() => {
    setToast((current) => ({ ...current, open: false }));
  }, []);

  const toastNode = (
    <Snackbar
      open={toast.open}
      autoHideDuration={4000}
      onClose={closeToast}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity={toast.severity} variant="filled" onClose={closeToast}>
        {toast.message}
      </Alert>
    </Snackbar>
  );

  return { showToast, toastNode };
}
